import React from 'react';
import CheckList from '../../../../lib/CheckList/CheckList';

interface ICompletedStepProps {
  creditAmount?: number;
  currencySymbol?: string;
  expiryDate?: string;
}

const CompletedStep: React.FC<React.PropsWithChildren<React.PropsWithChildren<ICompletedStepProps>>> = ({
  creditAmount,
  currencySymbol = '$',
  expiryDate,
}) => {
  return (
    <div>
      <CheckList
        items={[
          'Your booking has been cancelled',
          'The stylist has been notified',
          {
            title: `A credit of ${currencySymbol}${creditAmount} has been applied to your FLAYR account`,
            subTitle: `You can use this credit on a deposit for a future booking placed anytime before ${expiryDate} (the event itself can be after this date)`,
          },
        ]}
        titleClassName="lg:text-white"
        subTitleClassName="lg:text-gray-200"
      />
    </div>
  );
};
export default CompletedStep;
